export default "__VITE_ASSET__b39f9c48__"